import React, { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { Redirect, useHistory, useParams } from 'react-router-dom'

import { MODAL_ROUTE_URLS } from 'router/modalRoutes'
import { ROUTE_URLS } from 'router/routes'

import { selectLocaleDict } from 'features/locale/selectors'

import { useModalContext } from '@bcraft-frontend-lib/core'

import { addNotify } from 'components/Notify'

type ResetPasswordConfirmParams = {
  token: string
}

export const ResetPasswordConfirmPage = () => {
  const history = useHistory()

  const locale = useSelector(selectLocaleDict).common

  const { pushNewModal } = useModalContext()

  const { token } = useParams<ResetPasswordConfirmParams>()

  useEffect(() => {
    history.push(ROUTE_URLS.MAIN())

    if (!token) {
      addNotify(locale.resetPasswordTokenNotProvided)
    } else {
      pushNewModal(MODAL_ROUTE_URLS.RESET_PASSWORD_CONFIRM(token))()
    }
  }, [token])

  return null
}
